// @ts-nocheck
import * as React from "react";

const Chat: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M20.022 7.778c1.092 0 1.978.885 1.978 1.978v5.883a1.98 1.98 0 0 1-1.978 1.978h-3.983l-5.067 3.686c-.9.655-2.102-.26-1.712-1.303l.899-2.4a1.98 1.98 0 0 1-1.656-1.387l1.661-1.208h3.44a3.645 3.645 0 0 0 3.646-3.645V7.778z"
            />
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.605 3.5c1.092 0 1.977.885 1.977 1.978v5.882a1.98 1.98 0 0 1-1.978 1.978H9.622l-5.067 3.687c-.901.654-2.103-.26-1.712-1.303l.898-2.4A1.977 1.977 0 0 1 2 11.36V5.478c0-1.093.886-1.979 1.979-1.979zm-8.46 5.93a.66.66 0 0 0-.457.182.61.61 0 0 0-.14.677.62.62 0 0 0 .35.337.7.7 0 0 0 .248.047h7.152a.66.66 0 0 0 .457-.182.6.6 0 0 0 .188-.44.6.6 0 0 0-.188-.439.66.66 0 0 0-.457-.182zm0-3.43a.66.66 0 0 0-.457.182.61.61 0 0 0 .21 1.014.7.7 0 0 0 .248.047h7.152a.66.66 0 0 0 .457-.182.61.61 0 0 0 0-.879.66.66 0 0 0-.457-.182z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Chat);
